const initialState = {
    conversations: [],
    filters: {},
    selectedConversation: null,
    loadingConversation: false,
    loading: false,
    sending: false,
    capabilities: {
        email: true,
        whatsapp: false
    }
}

const inboxReducer = (
    state = initialState,
    action
) => {
    switch (action.type) {
        case 'INBOX_FILTERS':
            return { ...state, filters: action.params }
        case 'INBOX_LOADING':
            return {
                ...state,
                loading: true
            }
        case 'GET_CONVERSATIONS':
            return {
                ...state,
                loading: false,
                conversations: action.data,
                capabilities: action.capabilities,
                error: null
            }
        case 'CONVERSATION_DETAIL_ERROR':
            return {
                ...state,
                loadingConversation: false
            }
        case 'CONVERSATION_DETAIL_LOADING':
            return {
                ...state,
                loadingConversation: true
            }
        case 'SELECT_CONVERSATION':
            return {
                ...state,
                loadingConversation: false,
                selectedConversation: action.data
            }
        case 'UPDATE_CONVERSATION':
            return {
                ...state,
                selectedConversation: action.data,
                conversations: state.conversations.map(
                    item => (item.id === action.data.id ? {
                        ...item,
                        ...action.data
                    } : item)
                )
            }
        case 'WHATSAPP_MARKED_READ':
            return {
                ...state,
                conversations: state.conversations.map(item => (item.channel === 'WHATSAPP' && item.id === action.id ? { ...item, unread: false } : item))
            }
        case 'WHATSAPP_HISTORY_LOADED': {
            const current = state.selectedConversation
            if (current?.channel !== 'WHATSAPP' || current.id !== action.data.id) return state
            const identity = message => message.message_sid || `${message.sender || message.direction}-${message.id}`
            const returned = new Set(action.data.messages.map(identity))
            return {
                ...state,
                selectedConversation: {
                    ...current,
                    messages_from: action.data.messages_from,
                    has_older_messages: action.data.has_older_messages,
                    messages: [...action.data.messages, ...current.messages.filter(message => !returned.has(identity(message)))]
                }
            }
        }
        case 'SEND_MESSAGE_LOADING':
            return {
                ...state,
                sending: true
            }
        case 'ADD_MESSAGE':
            return {
                ...state,
                sending: false,
                selectedConversation: {
                    ...state.selectedConversation,
                    messages: [
                        ...state.selectedConversation.messages.filter(message => message.id !== action.data.id),
                        action.data
                    ]
                }
            }
        default:
            return state
    }
}

export default inboxReducer